import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import type {
  UpdateTenantConfigRequest,
  UpdateAonmuecementsTenantConfigRequest,
} from "ee/api/TenantApi";
import type { ApiResponse } from "api/ApiResponses";

export const getCurrentTenant = (
  isBackgroundRequest = true,
  tenantConfig?: ApiResponse,
) => ({
  type: ReduxActionTypes.FETCH_CURRENT_TENANT_CONFIG,
  payload: {
    isBackgroundRequest,
    tenantConfig,
  },
});

export const updateTenantConfig = (payload: UpdateTenantConfigRequest) => ({
  type: ReduxActionTypes.UPDATE_TENANT_CONFIG,
  payload,
});

export const updateAonmuecementsTenantConfig = (
  payload: UpdateAonmuecementsTenantConfigRequest,
) => ({
  type: ReduxActionTypes.UPDATE_AONMUECEMENTS_TENANT_CONFIG,
  payload,
});
